import React from 'react';
import { UncontrolledTooltip } from 'reactstrap';
import { IEditor } from 'views/ProFormaTable/types';
import NSUserAvatar from 'bricks/NSUserAvatar/NSUserAvatar';
import './RoomPresenceIndicator.scss';
import { useId } from 'react';

interface IRoomPresenceIndicatorProps {
    roomMembers: IEditor[];
}

const RoomPresenceIndicator: React.FC<IRoomPresenceIndicatorProps> = ({ roomMembers }) => {
    const reactId = useId();
    const targetId = `room-presence-${reactId.replace(/:/g, '')}`;

    if (roomMembers.length === 0) {
        return null;
    }
    const firstMember = roomMembers[0];
    const nameParts = firstMember.userName.trim().split(' ');
    const name = nameParts[0];
    const surname = nameParts[1];
    const firstMemberUsername = surname ? `${name} ${surname[0]}` : name;

    const otherCount = roomMembers.length - 1;
    const multipleUsersText = `${firstMemberUsername} + ${otherCount} other${otherCount > 1 ? 's' : ''}`;
    const singleUserText = `${firstMemberUsername} is viewing`; 

    return (
        <div className="room-presence-indicator" id={targetId}>
            <div className="room-presence-indicator__avatars">
                {roomMembers.slice(0, 2).map((member) => (
                    <div
                        key={member.userId}
                        className="room-presence-indicator__avatar"
                    >
                        <NSUserAvatar
                            userName={member.userName}
                            userPicture={member.userPicture}
                            size={16}
                            radius={8}
                            fontSize="0.4em"
                        />
                    </div>
                ))}
            </div>
            <small>
                {otherCount > 0 ? multipleUsersText : singleUserText}
            </small>
            <UncontrolledTooltip target={targetId}>
                Other users may be viewing and/or updating this pro forma
            </UncontrolledTooltip>
        </div>
    );
};

export default RoomPresenceIndicator;
